import * as ActionTypes from './actionTypes';
import apiActionCreator from '../../common/service/api/actionCreator';
import {buildErrorMessage} from '../../common/util/errorUtils';

export const fetchWarrantyAdminStatus = () => apiActionCreator({
  'endpoint': '/warranties/status',
  'authenticated': true,
  'types': [
    ActionTypes.FETCHING_WARRANTY_ADMIN_STATUS,
    ActionTypes.FETCHED_WARRANTY_ADMIN_STATUS,
    [ActionTypes.FETCHED_WARRANTY_ADMIN_STATUS_FAILED, (error) => buildErrorMessage(error)],
  ],
  'microservice': 'part',
  'method': 'GET',
});

export const getWarrantyAdminImages = (code, dealerId) =>
  apiActionCreator({
    'endpoint': `/warranties/${code}/${dealerId}`,
    'authenticated': true,
    'types': [
      ActionTypes.FETCHING_TWC_WARRANTY_ADMIN_ATTACHMENTS,
      ActionTypes.FETCHED_TWC_WARRANTY_ADMIN_ATTACHMENTS,
      [ActionTypes.FETCHED_TWC_WARRANTY_ADMIN_ATTACHMENTS_FAILED, (error) => buildErrorMessage(error)],
    ],
    'microservice': 'form',
    'method': 'GET',
  });

export const getWarrantyAdminByCode = (code, numTwc, dealer) => (dispatch) => {
  return dispatch(
    apiActionCreator({
      'endpoint': `/warranties/${code}/${numTwc}/${dealer}`,
      'authenticated': true,
      'types': [
        ActionTypes.FETCHING_TWC_WARRANTIES_ADMIN_BY_ID,
        [
          (response) => {
            return {
              'type': ActionTypes.FETCHED_TWC_WARRANTIES_ADMIN_BY_ID,
            };
          },
        ],
        [ActionTypes.FETCHED_TWC_WARRANTIES_ADMIN_BY_ID_FAILED, (error) => buildErrorMessage(error)],
      ],
      'microservice': 'part',
      'method': 'GET',
    })
  );
};

export const getWarrantyAdminChassis = (chassis, campaign) => (dispatch) => {
  return dispatch(
    apiActionCreator({
      'endpoint': `/warranties/vehicle/${chassis}?campaign=${campaign}`,
      'authenticated': true,
      'types': [
        ActionTypes.FETCHING_TWC_WARRANTY_ADMIN_CHASSIS,
        ActionTypes.FETCHED_TWC_WARRANTY_ADMIN_CHASSIS,
        [ActionTypes.FETCHED_TWC_WARRANTY_ADMIN_CHASSIS_FAILED, (error) => buildErrorMessage(error)],
      ],
      'microservice': 'part',
      'method': 'GET',
    })
  );
};

export const fetchConditionListWarrantyAdmin = () => (dispatch) => {
  return dispatch(
    apiActionCreator({
      'endpoint': '/warranties/ingles/condition',
      'authenticated': true,
      'types': [
        ActionTypes.FETCHING_CONDITION_LIST_WARRANTY_ADMIN,
        ActionTypes.FETCHED_CONDITION_LIST_WARRANTY_ADMIN,
        [ActionTypes.FETCHED_CONDITION_LIST_WARRANTY_ADMIN_FAILED, (error) => buildErrorMessage(error)],
      ],
      'microservice': 'part',
      'method': 'GET',
    })
  );
};

export const fetchCauseListWarrantyAdmin = () => (dispatch) => {
  return dispatch(
    apiActionCreator({
      'endpoint': '/warranties/ingles/cause',
      'authenticated': true,
      'types': [
        ActionTypes.FETCHING_CAUSE_LIST_WARRANTY_ADMIN,
        ActionTypes.FETCHED_CAUSE_LIST_WARRANTY_ADMIN,
        [ActionTypes.FETCHED_CAUSE_LIST_WARRANTY_ADMIN_FAILED, (error) => buildErrorMessage(error)],
      ],
      'microservice': 'part',
      'method': 'GET',
    })
  );
};

export const fetchRepairListWarrantyAdmin = () => (dispatch) => {
  return dispatch(
    apiActionCreator({
      'endpoint': '/warranties/ingles/repair',
      'authenticated': true,
      'types': [
        ActionTypes.FETCHING_REPAIR_LIST_WARRANTY_ADMIN,
        ActionTypes.FETCHED_REPAIR_LIST_WARRANTY_ADMIN,
        [ActionTypes.FETCHED_REPAIR_LIST_WARRANTY_ADMIN_FAILED, (error) => buildErrorMessage(error)],
      ],
      'microservice': 'part',
      'method': 'GET',
    })
  );
};

export const clearWarrantyAdmin = () => {
  return {
    'type': ActionTypes.CLEAR_WARRANTY_ADMIN,
  };
};

export const clearWarrantiesAdmin = () => {
  return {
    'type': ActionTypes.CLEAR_WARRANTIES_ADMIN,
  };
};

export const clearWarrantyAdminChassis = () => {
  return {
    'type': ActionTypes.CLEAR_WARRANTY_ADMIN_CHASSIS,
  };
};

export const addConditionWarrantyAdmin = (condition) => ({
  'type': ActionTypes.ADD_CONDITION_WARRANTY_ADMIN,
  'payload': condition,
});

export const addCauseWarrantyAdmin = (cause) => ({
  'type': ActionTypes.ADD_CAUSE_WARRANTY_ADMIN,
  'payload': cause,
});

export const addRepairWarrantyAdmin = (repair) => ({
  'type': ActionTypes.ADD_REPAIR_WARRANTY_ADMIN,
  'payload': repair,
});
